import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Auditoria() {
  const [list, setList] = useState([]);
  const [entity, setEntity] = useState("");
  const [eid, setEid] = useState("");

  const load = () => {
    const q = new URLSearchParams();
    if (entity) q.append("entity", entity);
    if (eid) q.append("entity_id", eid);
    api.get(`/dashboard/auditoria?${q.toString()}`).then(r => setList(r.data));
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="p-8">
      <div className="mb-8">
        <div className="label-cap">Jurídico</div>
        <h1 className="font-heading font-extrabold text-3xl tracking-tighter mt-1">Auditoria Imutável</h1>
        <p className="text-sm text-muted-foreground mt-2">Trilha completa de todos os eventos do sistema. Nada é apagado.</p>
      </div>

      <div className="flex gap-3 mb-6">
        <Input placeholder="Entidade (servico, montador, empresa…)" value={entity} onChange={(e) => setEntity(e.target.value)} className="w-72" data-testid="audit-entity" />
        <Input placeholder="ID da entidade" value={eid} onChange={(e) => setEid(e.target.value)} className="w-96" data-testid="audit-eid" />
        <Button onClick={load} className="btn-sharp brand-bg text-white" data-testid="audit-buscar">Filtrar</Button>
      </div>

      <div className="border border-border bg-white">
        <table className="w-full text-sm">
          <thead className="border-b border-border bg-[#F4F4F5]">
            <tr><Th>Quando</Th><Th>Entidade</Th><Th>Ação</Th><Th>Usuário</Th><Th>IP</Th><Th>Detalhes</Th></tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-muted-foreground">Nenhum log encontrado</td></tr>}
            {list.map((l) => (
              <tr key={l.id} className="border-b border-border last:border-0 hover:bg-secondary" data-testid={`audit-${l.id}`}>
                <Td className="font-mono text-[10px]">{new Date(l.timestamp).toLocaleString("pt-BR")}</Td>
                <Td>{l.entity} <span className="text-[10px] font-mono text-muted-foreground">{l.entity_id?.slice(0,8)}</span></Td>
                <Td><strong>{l.action}</strong></Td>
                <Td>{l.user_email || "sistema"}<div className="text-xs text-muted-foreground">{l.user_role}</div></Td>
                <Td className="font-mono text-xs">{l.ip || "—"}</Td>
                <Td><pre className="text-[10px] whitespace-pre-wrap font-mono">{JSON.stringify(l.details, null, 0)}</pre></Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
function Th({ children }) { return <th className="text-left p-3 label-cap font-medium">{children}</th>; }
function Td({ children, className="" }) { return <td className={`p-3 ${className}`}>{children}</td>; }
